// extracted by mini-css-extract-plugin
export default {"zoomModal":"gha-z","image":"hha-z","button":"iha-z","isOverlayShown":"jha-z"};